import { useAdmission } from 'components/admission/InviteField'
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  ListItemButton, ListItemAvatar, ListItemText,
} from '@mui/material'
import { DashboardRounded as BusinessIcon, Add as AddIcon } from '@mui/icons-material'
import MenuItem from 'components/MenuItem'
import { useBusinessUser } from 'utils/roles'
import { fetchUser } from 'modules/User/actions'
import api from 'utils/api'

const BusinessAccountEntry = () => {
  const businessUser = useBusinessUser()
  const suspended = useSelector(state => state.user.details?.lifecycleStatus === 'SUSPENDED')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [converting, setConverting] = useState(false)
  const pending = useRef(false)
  const label = 'Enable business features'

  const admission = useAdmission('BUSINESS', open)
  const upgradeBlocked = admission.blocked || admission.status?.upgradeAvailable === false

  const convert = async () => {
    if (pending.current || suspended || upgradeBlocked) return
    pending.current = true
    setConverting(true)
    try {
      await api.post('/user/upgrade/business', {})
      dispatch(fetchUser())
      setOpen(false)
      navigate('/business')
    } catch (error) {
      admission.reload()
      enqueueSnackbar(error.message || 'Business features could not be enabled. Please try again.', { variant: 'error' })
    } finally {
      pending.current = false
      setConverting(false)
    }
  }

  if (businessUser) {
    return <MenuItem icon={<BusinessIcon sx={{ color: 'black' }} />} text="My business" link="/business" />
  }

  return (
    <>
      <ListItemButton
        component="button"
        type="button"
        disabled={suspended}
        onClick={() => setOpen(true)}
        sx={{
          width: '100%',
          pl: '22px',
          backgroundColor: '#eee',
          '&:hover': { backgroundColor: 'grey.300' },
        }}
      >
        <ListItemAvatar><AddIcon /></ListItemAvatar>
        <ListItemText primary={label} primaryTypographyProps={{ color: 'black' }} />
      </ListItemButton>
      <Dialog open={open && !suspended} onClose={() => !converting && setOpen(false)} fullWidth maxWidth="sm" aria-labelledby="convert-business-title">
        <DialogTitle id="convert-business-title">{label}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enable business features to add your business and advertise offers.
            {' '}You will keep your personal profile, favorites, claimed offers, and alerts.
          </DialogContentText>
          {admission.status?.upgradeAvailable === false && <DialogContentText sx={{ mt: 2 }}>
            Business account places are currently full.
          </DialogContentText>}
        </DialogContent>
        <DialogActions>
          <Button disabled={converting} onClick={() => setOpen(false)}>Cancel</Button>
          <Button disabled={converting || suspended || upgradeBlocked} variant="contained" onClick={convert}>
            {converting ? 'Enabling' : 'Enable business features'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default BusinessAccountEntry
